// THE SHARED VOCABULARY — the German every page speaks alike: the verbs, the statuses, the
// priorities, the requirement types, the phase labels, the commercial models, the small words.
// Registered once from PageKit (always in the bundle), so a page catalogue need not repeat
// these; a page that does repeat one with the SAME value is harmless, a differing value warns.
import { registerDe } from './index.js';

registerDe({
  // ── verbs ──
  'Save': 'Speichern',
  'Cancel': 'Abbrechen',
  'Close': 'Schliessen',
  'Delete': 'Löschen',
  'Edit': 'Bearbeiten',
  'Add': 'Hinzufügen',
  'New': 'Neu',
  'Remove': 'Entfernen',
  'Search': 'Suchen',
  'Revert': 'Verwerfen',
  'Refresh': 'Aktualisieren',
  'Confirm': 'Bestätigen',
  'Hold': 'Übernehmen',
  'Refuse': 'Ablehnen',
  'Amend': 'Anpassen',
  'Restore': 'Wiederherstellen',
  'Descope': 'Aus dem Umfang nehmen',
  'Sign': 'Unterzeichnen',
  'Reading…': 'Wird geladen…',
  'Loading…': 'Wird geladen…',
  'Saving…': 'Wird gespeichert…',

  // ── the small words ──
  'nothing edited': 'nichts geändert',
  'not named': 'nicht benannt',
  'not set': 'nicht gesetzt',
  'undated': 'ohne Datum',
  'none': 'keine',
  'The change was refused.': 'Die Änderung wurde abgelehnt.',
  'working days': 'Arbeitstage',
  'due': 'fällig',
  'Due': 'Fällig',
  'Due date': 'Fälligkeitsdatum',
  'Start date': 'Startdatum',
  'Currency': 'Währung',
  'Estimate': 'Schätzung',
  'Budget': 'Budget',
  'Language': 'Sprache',
  'Correspondence language': 'Korrespondenzsprache',

  // ── statuses (as the register and the deliverables carry them) ──
  'draft': 'Entwurf',
  'Draft': 'Entwurf',
  'pending': 'ausstehend',
  'Pending': 'Ausstehend',
  'confirmed': 'bestätigt',
  'Confirmed': 'Bestätigt',
  'baselined': 'in der Baseline',
  'Baselined': 'In der Baseline',
  'delivered': 'geliefert',
  'Delivered': 'Geliefert',
  'accepted': 'abgenommen',
  'Accepted': 'Abgenommen',
  'accepted_with_edits': 'mit Änderungen abgenommen',
  'dropped': 'verworfen',
  'Dropped': 'Verworfen',
  'descoped': 'aus dem Umfang genommen',
  'Descoped': 'Aus dem Umfang genommen',
  'planned': 'geplant',
  'Planned': 'Geplant',
  'in progress': 'in Arbeit',
  'in_progress': 'in Arbeit',
  'In progress': 'In Arbeit',
  'refused': 'abgelehnt',
  'Refused': 'Abgelehnt',
  'rejected': 'abgelehnt',
  'Rejected': 'Abgelehnt',
  'amended': 'angepasst',
  'Amended': 'Angepasst',
  'held': 'übernommen',
  'Held': 'Übernommen',
  'untreated': 'unbehandelt',
  'treated': 'behandelt',

  // ── priorities ──
  'must': 'Muss',
  'should': 'Soll',
  'could': 'Kann',
  "won't": 'Nicht',
  'wont': 'Nicht',
  'Must': 'Muss',
  'Should': 'Soll',
  'Could': 'Kann',
  "Won't": 'Nicht',

  // ── requirement types ──
  'functional': 'funktional',
  'non-functional': 'nicht-funktional',
  'non_functional': 'nicht-funktional',
  'constraint': 'Rahmenbedingung',
  'assumption': 'Annahme',
  'out of scope': 'ausserhalb des Umfangs',
  'out_of_scope': 'ausserhalb des Umfangs',
  'Functional': 'Funktional',
  'Non-functional': 'Nicht-funktional',
  'Constraint': 'Rahmenbedingung',
  'Assumption': 'Annahme',
  'Out of scope': 'Ausserhalb des Umfangs',

  // ── phases (crm.PHASE_LABELS) ──
  'Qualify': 'Qualifizierung',
  'Discovery': 'Discovery',
  'Design': 'Konzeption',
  'Contracting': 'Vertrag',
  'Mobilise': 'Mobilisierung',
  'Implement': 'Umsetzung',
  'Acceptance': 'Abnahme',
  'Handover': 'Übergabe',
  // 'Close' the phase (Abschluss) collides with 'Close' the verb (Schliessen) — the verb wins here;
  // the page that renders the phase list must use a distinct key for that one label.

  // ── commercial models (crm.COMMERCIAL_MODEL_LABELS) ──
  'Fixed price': 'Festpreis',
  'Time & materials': 'Nach Aufwand',
  'Capped T&M': 'Nach Aufwand mit Kostendach',
  'Retainer': 'Retainer',

  // ── actors ──
  'agent': 'Agent',
  'operator': 'Operator',
  'portal': 'Portal',
  'Agent': 'Agent',
  'Operator': 'Operator',
  'Portal': 'Portal',
}, 'common');
